import { PageWrapper } from "../../shared-components";

function AboutScreen() {
  return (
    <PageWrapper>
      <main>
        <h1>About</h1>
        <h2>Why does everything end up here?</h2>
        <p>
          With the latest interation of my blog there are many things that are a
          work-in-progress. If you are seeing this message then you ended up
          here before I have any (or all of the) pages set up. Congrats 🎉
        </p>
        <p>
          Check back soon as things should be filling in nicely over the next
          couple of weeks!
        </p>
      </main>
    </PageWrapper>
  );
}

export default AboutScreen;
